/*
  Barra de navegação do celular (snippets/barra-inferior.liquid).
  - Categorias: pede a lista da barra de categorias (assets/barra-categorias.js); sem ela, o link segue.
  - Moto: volta ao topo e abre os campos da faixa "Minha moto" (assets/minha-moto.js); sem ela, o item fica escondido.
  - Carrinho: abre a gaveta (assets/cart-drawer.js); o número copia o do ícone do cabeçalho, que o tema
    redesenha a cada mudança no carrinho.
*/
(() => {
  const barra = document.querySelector('[data-bi]');
  if (!barra || barra.dataset.iniciada) return;
  barra.dataset.iniciada = 'true';

  const categorias = barra.querySelector('[data-bi-categorias]');
  categorias?.addEventListener('click', (event) => {
    const pedido = new CustomEvent('barra-categorias:lista', { cancelable: true, detail: { origem: categorias } });
    if (!document.dispatchEvent(pedido)) event.preventDefault();
  });

  const faixa = document.querySelector('.mm');
  const abrirFaixa = faixa?.querySelector('[data-mm-abrir]');
  const moto = barra.querySelector('[data-bi-moto]');
  if (abrirFaixa && moto) {
    moto.closest('[data-bi-moto-item]').hidden = false;
    moto.addEventListener('click', () => {
      if (abrirFaixa.getAttribute('aria-expanded') !== 'true') {
        abrirFaixa.click();
      } else {
        faixa.querySelector('select')?.focus({ preventScroll: true });
      }
      window.scrollTo({
        top: 0,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
    });
  }

  const carrinho = barra.querySelector('[data-bi-carrinho]');
  carrinho?.addEventListener('click', (event) => {
    const gaveta = document.querySelector('cart-drawer');
    if (typeof gaveta?.open !== 'function') return;
    event.preventDefault();
    gaveta.open(carrinho);
  });

  const contagem = barra.querySelector('[data-bi-contagem]');
  const contagemTexto = barra.querySelector('[data-bi-contagem-texto]');
  const icone = document.getElementById('cart-icon-bubble');
  if (contagem && icone) {
    const copiar = () => {
      const bolha = icone.querySelector('.cart-count-bubble');
      const numero = bolha?.querySelector('[aria-hidden="true"]')?.textContent.trim();
      contagem.hidden = !bolha;
      contagem.textContent = numero || (bolha ? '99+' : '');
      if (contagemTexto) contagemTexto.textContent = bolha?.querySelector('.visually-hidden')?.textContent.trim() || '';
    };
    new MutationObserver(copiar).observe(icone, { childList: true, subtree: true, characterData: true });
  }
})();
